import clsx from "clsx"

type Props = {
  list: {
    title: string
    backgroundColor: string
    borderColor?: string
  }[]
}

const Legend = ({ list }: Props) => {
  return (
    <div className="flex flex-wrap">
      {list.map(item => (
        <div
          key={item.title}
          className="mb-0.5 mr-2.5 grid grid-flow-col items-center justify-start gap-0.75"
        >
          <div
            className={clsx(
              item.backgroundColor,
              item.borderColor,
              "size-2 rounded-[4px]"
            )}
          />
          <span>{item.title}</span>
        </div>
      ))}
    </div>
  )
}

export default Legend
